export default "__VITE_ASSET__92c8b8d0__"